export default __webpack_public_path__ + "static/media/background.e888e57a.jpg";